import React from "react";
import { Link } from "react-router-dom";
import { LinkedinLogo, FacebookLogo, InstagramLogo, MapPin, Phone, EnvelopeSimple } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy-900 text-white/85">
      <div className="container-tight py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="inline-flex bg-white rounded-xl p-3">
            <img src="/cretre-logo.jpg" alt="CRETRE" className="h-20 w-auto object-contain" />
          </div>
          <p className="mt-4 text-sm tracking-[0.22em] uppercase text-gold-400">People · Process · Performance</p>
          <p className="mt-6 text-sm leading-relaxed text-white/70">
            End-to-end workforce, recruitment, payroll and compliance solutions for businesses across India.
          </p>
          <div className="mt-6 flex gap-3">
            <a href="#" aria-label="LinkedIn" data-testid="footer-linkedin" className="h-10 w-10 grid place-items-center rounded-full border border-white/15 hover:bg-white/10 transition-colors">
              <LinkedinLogo size={18} />
            </a>
            <a href="#" aria-label="Facebook" data-testid="footer-facebook" className="h-10 w-10 grid place-items-center rounded-full border border-white/15 hover:bg-white/10 transition-colors">
              <FacebookLogo size={18} />
            </a>
            <a href="#" aria-label="Instagram" data-testid="footer-instagram" className="h-10 w-10 grid place-items-center rounded-full border border-white/15 hover:bg-white/10 transition-colors">
              <InstagramLogo size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold-400 font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {[
              ["/", "Home"], ["/about", "About"], ["/services", "Services"], ["/industries", "Industries"],
              ["/jobs", "Jobs"], ["/employers", "Employers"], ["/contact", "Contact"],
            ].map(([to, label]) => (
              <li key={to}><Link to={to} className="text-white/70 hover:text-gold-400 transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold-400 font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Staffing & Manpower</li>
            <li>Recruitment</li>
            <li>Payroll</li>
            <li>Compliance</li>
            <li>White Collar Recruitment</li>
            <li>HR Consulting</li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold-400 font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2"><MapPin size={18} className="mt-0.5 text-gold-400 shrink-0" /><span>Ahmedabad, Gujarat, India</span></li>
            <li className="flex items-center gap-2"><Phone size={18} className="text-gold-400 shrink-0" /><a href="tel:+919057862163" className="hover:text-gold-400">+91 90578 62163</a></li>
            <li className="flex items-center gap-2"><EnvelopeSimple size={18} className="text-gold-400 shrink-0" /><a href="mailto:business@infocretregroup.in" className="hover:text-gold-400 break-all">business@infocretregroup.in</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-tight py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© 2026 CRETRE. All Rights Reserved.</p>
          <p>Manpower · Recruitment · Payroll · Compliance · Consulting</p>
        </div>
      </div>
    </footer>
  );
}
